import { FC } from 'react'

import { ISvgClass } from '../interface'

const InvoiceIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M967 4682 l-437 -437 0 -1813 0 -1812 310 0 310 0 0 -310 0 -310 1720 0 1720 0 0 2250 0 2250 -310 0 -310 0 0 310 0 310 -1283 0 -1282 0 -438 -438z m2703 -1812 l0 -1950 -1420 0 -1420 0 2 1558 3 1557 393 3 392 2 0 390 0 390 1025 0 1025 0 0 -1950z m-2350 1600 l0 -130 -137 0 -138 0 130 130 c71 72 133 130 137 130 5 0 8 -58 8 -130z m2970 -2220 l0 -1950 -1420 0 -1420 0 0 160 0 160 1260 0 1260 0 0 1790 0 1790 160 0 160 0 0 -1950z" />
        <path d="M2120 4290 l0 -139 -54 -26 c-275 -130 -315 -512 -72 -695 71 -54 146 -79 257 -87 76 -5 96 -10 120 -30 59 -50 44 -149 -26 -179 -81 -34 -173 -8 -202 57 l-17 39 -148 0 c-169 0 -159 7 -133 -95 32 -123 113 -222 223 -272 l52 -24 0 -140 0 -139 150 0 150 0 0 138 0 137 64 33 c169 88 258 281 212 462 -33 127 -106 216 -224 273 -52 24 -82 31 -163 37 -77 5 -106 11 -127 27 -61 45 -66 121 -12 167 77 64 215 35 236 -51 6 -23 7 -23 155 -23 170 0 162 -6 135 96 -31 118 -112 216 -222 270 l-54 26 0 139 0 139 -150 0 -150 0 0 -140z" />
        <path d="M1240 2110 l0 -150 1005 0 1005 0 0 150 0 150 -1005 0 -1005 0 0 -150z" />
        <path d="M1240 1510 l0 -150 1005 0 1005 0 0 150 0 150 -1005 0 -1005 0 0 -150z" />
      </g>
    </svg>
  )
}

export default InvoiceIcon
